// workaround for null elements in React.JSX,
// such as for alurkerja-ui Table component customButtonDetail and customButtonEdit props

import { Null } from "./null";

export function nullElement() {
  return <Null />;
}
